<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { MealDishFragment } from '@/graphql/custom-types';

interface Props {
  dishes: MealDishFragment[];
}

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <BasicBlock
    :icon="['far', 'soup']"
    :ariaDescription="`${$t('global.dishes')}`"
  >
    <div>
      <div
        v-for="(dish, index) in dishes"
        :key="index"
        class="w-148 bg-neutral-0 rounded-xl p-4 mb-8"
        :aria-label="dish.title"
      >
        <p class="mb-2">{{ dish.title }}</p>
        <img
          v-if="dish.picture"
          class="max-h-77.5 object-cover w-140"
          v-optimized="{ size: 'medium', src: dish?.picture?.source }"
        />
      </div>
    </div>
  </BasicBlock>
</template>
